@for (p of products; track p) {
  <mbnm-shop-detail-product-block [product]="p">
  </mbnm-shop-detail-product-block>
}
